import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    modeClassic: 'Classic',
    modeCrazy: 'Crazy',
    modeSharing: 'Split',
    modeLastCase: 'Last case',
    modeClassicRule: 'The biggest total takes every drop',
    modeCrazyRule: 'The smallest total takes every drop',
    modeSharingRule: 'Nobody loses: all drops are split between players',
    modeLastCaseRule: 'Only the last case counts: the best drop in it takes everything',
    format2: '1 vs 1',
    format3: '3 players',
    format4: '4 players',
    formatTeam: '2 vs 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Private',
    bandFinal: 'Headliners',
    viewers: 'Watching',
    bank: 'Total drops',
    entry: 'Entry',
    statusWaiting: 'Waiting',
    statusRunning: 'Live',
    statusCompleted: 'Finished',
    statusCancelled: 'Cancelled',
    settingsTitle: 'Battle settings',
    settingsReactions: 'Reactions',
    settingsReactionsHint: 'Emoji from players and viewers',
    settingsAffordable: 'Only within my balance',
    settingsAffordableHint: 'Hide battles you cannot afford to enter',
    settingsHideRunning: 'Hide battles in progress',
    settingsHideRunningHint: 'Show only battles you can still join',
    emptyFiltered: 'Nothing matches your settings',
    emptyFilteredHint: 'Turn off a filter in the settings to see more battles',
    reasonNotWaiting: 'The battle has already started',
    reasonFull: 'No free seats',
    reasonAlreadyIn: 'You are in',
    reasonInsufficientBalance: 'Not enough balance',
    reasonTradeLinkRequired: 'Add your trade link first',
    reasonMaxActiveBattles: 'You already have {{limit}} active battles',
    reasonWithdrawalsBlocked: 'Battles are unavailable for your account',
    reasonMultiacc: 'A linked account is already in this battle',
    reasonNotParticipant: 'Only players can do this',
    reasonNotCompleted: 'Wait for the battle to finish',
    reasonNothingToSell: 'Nothing to sell',
    reasonRematchExpired: 'The rematch invite has expired',
    reasonRematchExists: 'A rematch is already set up',
    reasonNoOpponents: 'No one to play with yet',
  },
  ru: {
    modeClassic: 'Классика',
    modeCrazy: 'Crazy',
    modeSharing: 'Поровну',
    modeLastCase: 'Последний кейс',
    modeClassicRule: 'Кто выбил больше — забирает все дропы',
    modeCrazyRule: 'Кто выбил меньше — забирает все дропы',
    modeSharingRule: 'Никто не в минусе: все дропы делятся между игроками',
    modeLastCaseRule: 'Считается только последний кейс: лучший дроп из него забирает всё',
    format2: '1 на 1',
    format3: '3 игрока',
    format4: '4 игрока',
    formatTeam: '2 на 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Приватный',
    bandFinal: 'Хедлайнеры',
    viewers: 'Смотрят',
    bank: 'Всего выбито',
    entry: 'Вход',
    statusWaiting: 'Ожидание',
    statusRunning: 'Идёт',
    statusCompleted: 'Завершён',
    statusCancelled: 'Отменён',
    settingsTitle: 'Настройки баттлов',
    settingsReactions: 'Реакции',
    settingsReactionsHint: 'Эмодзи игроков и зрителей',
    settingsAffordable: 'Только по балансу',
    settingsAffordableHint: 'Скрывать баттлы, на вход в которые не хватает',
    settingsHideRunning: 'Скрывать идущие',
    settingsHideRunningHint: 'Показывать только баттлы, куда ещё можно войти',
    emptyFiltered: 'Под настройки ничего не подходит',
    emptyFilteredHint: 'Выключи фильтр в настройках, чтобы увидеть больше баттлов',
    reasonNotWaiting: 'Баттл уже стартовал',
    reasonFull: 'Свободных мест нет',
    reasonAlreadyIn: 'Ты в игре',
    reasonInsufficientBalance: 'Не хватает баланса',
    reasonTradeLinkRequired: 'Сначала добавь трейд-ссылку',
    reasonMaxActiveBattles: 'У тебя уже {{limit}} активных баттла',
    reasonWithdrawalsBlocked: 'Баттлы недоступны для твоего аккаунта',
    reasonMultiacc: 'В этом баттле уже есть связанный аккаунт',
    reasonNotParticipant: 'Это могут только игроки',
    reasonNotCompleted: 'Дождись конца баттла',
    reasonNothingToSell: 'Продавать нечего',
    reasonRematchExpired: 'Приглашение на реванш истекло',
    reasonRematchExists: 'Реванш уже создан',
    reasonNoOpponents: 'Пока не с кем играть',
  },
  uz: {
    modeClassic: 'Klassik',
    modeCrazy: 'Crazy',
    modeSharing: 'Teng',
    modeLastCase: 'Oxirgi keys',
    modeClassicRule: 'Kim koʻproq chiqargan boʻlsa — barcha droplarni oladi',
    modeCrazyRule: 'Kim kamroq chiqargan boʻlsa — barcha droplarni oladi',
    modeSharingRule: 'Hech kim yutqazmaydi: barcha droplar oʻyinchilar orasida boʻlinadi',
    modeLastCaseRule: 'Faqat oxirgi keys hisobga olinadi: undagi eng yaxshi drop hammasini oladi',
    format2: '1 ga 1',
    format3: '3 oʻyinchi',
    format4: '4 oʻyinchi',
    formatTeam: '2 ga 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Shaxsiy',
    bandFinal: 'Xedlaynerlar',
    viewers: 'Tomosha qilmoqda',
    bank: 'Jami chiqdi',
    entry: 'Kirish',
    statusWaiting: 'Kutilmoqda',
    statusRunning: 'Jonli',
    statusCompleted: 'Tugadi',
    statusCancelled: 'Bekor qilindi',
    settingsTitle: 'Jang sozlamalari',
    settingsReactions: 'Reaksiyalar',
    settingsReactionsHint: 'Oʻyinchi va tomoshabinlar emojisi',
    settingsAffordable: 'Faqat balansga yarasha',
    settingsAffordableHint: 'Kirishga pul yetmaydigan janglarni yashirish',
    settingsHideRunning: 'Boshlanganlarni yashirish',
    settingsHideRunningHint: 'Faqat hali kirish mumkin boʻlgan janglar',
    emptyFiltered: 'Sozlamalarga mos jang yoʻq',
    emptyFilteredHint: 'Koʻproq jang koʻrish uchun sozlamalarda filtrni oʻchir',
    reasonNotWaiting: 'Battle allaqachon boshlangan',
    reasonFull: 'Boʻsh joy yoʻq',
    reasonAlreadyIn: 'Sen oʻyindasan',
    reasonInsufficientBalance: 'Balans yetarli emas',
    reasonTradeLinkRequired: 'Avval trade-havolani qoʻsh',
    reasonMaxActiveBattles: 'Senda allaqachon {{limit}} ta faol battle bor',
    reasonWithdrawalsBlocked: 'Battlelar sening akkauntingga ochiq emas',
    reasonMultiacc: 'Bu battleda bogʻlangan akkaunt allaqachon bor',
    reasonNotParticipant: 'Buni faqat oʻyinchilar qila oladi',
    reasonNotCompleted: 'Battle tugashini kut',
    reasonNothingToSell: 'Sotadigan narsa yoʻq',
    reasonRematchExpired: 'Revansh taklifi muddati oʻtdi',
    reasonRematchExists: 'Revansh allaqachon yaratilgan',
    reasonNoOpponents: 'Hozircha oʻynaydigan odam yoʻq',
  },
  fa: {
    modeClassic: 'کلاسیک',
    modeCrazy: 'Crazy',
    modeSharing: 'مساوی',
    modeLastCase: 'کیس آخر',
    modeClassicRule: 'هر کس بیشتر درآورد همه دراپ‌ها را می‌برد',
    modeCrazyRule: 'هر کس کمتر درآورد همه دراپ‌ها را می‌برد',
    modeSharingRule: 'هیچ‌کس ضرر نمی‌کند: همه دراپ‌ها بین بازیکن‌ها تقسیم می‌شود',
    modeLastCaseRule: 'فقط کیس آخر حساب می‌شود: بهترین دراپ آن همه چیز را می‌برد',
    format2: '1 به 1',
    format3: '3 بازیکن',
    format4: '4 بازیکن',
    formatTeam: '2 به 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'خصوصی',
    bandFinal: 'هدلاینرها',
    viewers: 'در حال تماشا',
    bank: 'مجموع دراپ‌ها',
    entry: 'ورود',
    statusWaiting: 'در انتظار',
    statusRunning: 'زنده',
    statusCompleted: 'تمام‌شده',
    statusCancelled: 'لغو شد',
    settingsTitle: 'تنظیمات نبرد',
    settingsReactions: 'واکنش‌ها',
    settingsReactionsHint: 'ایموجی بازیکنان و تماشاگران',
    settingsAffordable: 'فقط در حد موجودی',
    settingsAffordableHint: 'نبردهایی که پول ورودشان را نداری پنهان شوند',
    settingsHideRunning: 'پنهان کردن نبردهای در جریان',
    settingsHideRunningHint: 'فقط نبردهایی که هنوز می‌توان وارد شد',
    emptyFiltered: 'هیچ نبردی با تنظیمات مطابقت ندارد',
    emptyFilteredHint: 'برای دیدن نبردهای بیشتر، فیلتر را در تنظیمات خاموش کن',
    reasonNotWaiting: 'بتل از قبل شروع شده',
    reasonFull: 'جای خالی نیست',
    reasonAlreadyIn: 'تو در بازی هستی',
    reasonInsufficientBalance: 'موجودی کافی نیست',
    reasonTradeLinkRequired: 'اول لینک ترید را اضافه کن',
    reasonMaxActiveBattles: 'تو از قبل {{limit}} بتل فعال داری',
    reasonWithdrawalsBlocked: 'بتل برای حساب تو در دسترس نیست',
    reasonMultiacc: 'یک حساب مرتبط از قبل در این بتل است',
    reasonNotParticipant: 'فقط بازیکن‌ها می‌توانند',
    reasonNotCompleted: 'صبر کن بتل تمام شود',
    reasonNothingToSell: 'چیزی برای فروش نیست',
    reasonRematchExpired: 'دعوت بازی مجدد منقضی شد',
    reasonRematchExists: 'بازی مجدد از قبل ساخته شده',
    reasonNoOpponents: 'هنوز کسی برای بازی نیست',
  },
  pt: {
    modeClassic: 'Clássico',
    modeCrazy: 'Crazy',
    modeSharing: 'Dividido',
    modeLastCase: 'Última caixa',
    modeClassicRule: 'Quem tirar mais leva todos os drops',
    modeCrazyRule: 'Quem tirar menos leva todos os drops',
    modeSharingRule: 'Ninguém sai no prejuízo: todos os drops são divididos entre os jogadores',
    modeLastCaseRule: 'Só a última caixa conta: o melhor drop dela leva tudo',
    format2: '1 x 1',
    format3: '3 jogadores',
    format4: '4 jogadores',
    formatTeam: '2 x 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Privada',
    bandFinal: 'Headliners',
    viewers: 'Assistindo',
    bank: 'Total de drops',
    entry: 'Entrada',
    statusWaiting: 'Aguardando',
    statusRunning: 'Ao vivo',
    statusCompleted: 'Concluída',
    statusCancelled: 'Cancelada',
    settingsTitle: 'Configurações das batalhas',
    settingsReactions: 'Reações',
    settingsReactionsHint: 'Emojis de jogadores e espectadores',
    settingsAffordable: 'Só dentro do meu saldo',
    settingsAffordableHint: 'Esconder batalhas cuja entrada você não pode pagar',
    settingsHideRunning: 'Esconder batalhas em andamento',
    settingsHideRunningHint: 'Mostrar só batalhas em que ainda dá para entrar',
    emptyFiltered: 'Nada corresponde às suas configurações',
    emptyFilteredHint: 'Desative um filtro nas configurações para ver mais batalhas',
    reasonNotWaiting: 'A batalha já começou',
    reasonFull: 'Não há vagas',
    reasonAlreadyIn: 'Você está dentro',
    reasonInsufficientBalance: 'Saldo insuficiente',
    reasonTradeLinkRequired: 'Adicione seu link de troca primeiro',
    reasonMaxActiveBattles: 'Você já tem {{limit}} batalhas ativas',
    reasonWithdrawalsBlocked: 'As batalhas não estão disponíveis para sua conta',
    reasonMultiacc: 'Já existe uma conta vinculada nesta batalha',
    reasonNotParticipant: 'Só os jogadores podem fazer isso',
    reasonNotCompleted: 'Espere a batalha terminar',
    reasonNothingToSell: 'Nada para vender',
    reasonRematchExpired: 'O convite de revanche expirou',
    reasonRematchExists: 'A revanche já foi criada',
    reasonNoOpponents: 'Ainda não há ninguém para jogar',
  },
  tr: {
    modeClassic: 'Klasik',
    modeCrazy: 'Crazy',
    modeSharing: 'Paylaşımlı',
    modeLastCase: 'Son kasa',
    modeClassicRule: 'En çok çıkaran tüm dropları alır',
    modeCrazyRule: 'En az çıkaran tüm dropları alır',
    modeSharingRule: 'Kimse kaybetmez: tüm droplar oyuncular arasında paylaşılır',
    modeLastCaseRule: 'Sadece son kasa sayılır: ondan çıkan en iyi drop her şeyi alır',
    format2: '1v1',
    format3: '3 oyuncu',
    format4: '4 oyuncu',
    formatTeam: '2v2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Özel',
    bandFinal: 'Headliner’lar',
    viewers: 'İzliyor',
    bank: 'Toplam drop',
    entry: 'Giriş',
    statusWaiting: 'Bekliyor',
    statusRunning: 'Canlı',
    statusCompleted: 'Bitti',
    statusCancelled: 'İptal edildi',
    settingsTitle: 'Savaş ayarları',
    settingsReactions: 'Tepkiler',
    settingsReactionsHint: 'Oyuncu ve izleyicilerin emojileri',
    settingsAffordable: 'Sadece bakiyeme uygun',
    settingsAffordableHint: 'Girişine bakiyen yetmeyen savaşları gizle',
    settingsHideRunning: 'Devam edenleri gizle',
    settingsHideRunningHint: 'Sadece hâlâ girilebilen savaşları göster',
    emptyFiltered: 'Ayarlarına uyan savaş yok',
    emptyFilteredHint: 'Daha fazla savaş görmek için ayarlardan bir filtreyi kapat',
    reasonNotWaiting: 'Savaş çoktan başladı',
    reasonFull: 'Boş yer yok',
    reasonAlreadyIn: 'Oyundasın',
    reasonInsufficientBalance: 'Bakiye yetersiz',
    reasonTradeLinkRequired: 'Önce takas linkini ekle',
    reasonMaxActiveBattles: 'Zaten {{limit}} aktif savaşın var',
    reasonWithdrawalsBlocked: 'Savaşlar hesabın için kullanılamıyor',
    reasonMultiacc: 'Bu savaşta zaten bağlantılı bir hesap var',
    reasonNotParticipant: 'Bunu sadece oyuncular yapabilir',
    reasonNotCompleted: 'Savaşın bitmesini bekle',
    reasonNothingToSell: 'Satacak bir şey yok',
    reasonRematchExpired: 'Rövanş daveti süresi doldu',
    reasonRematchExists: 'Rövanş zaten oluşturuldu',
    reasonNoOpponents: 'Henüz oynayacak kimse yok',
  },
});
